import React from 'react';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { Site, SiteConfig } from '@99designs/frontend-components/apps/global-nav/lib/Site';
import { BackendSubscriptionClientProvider } from '@99designs/apps/spa/common/ApolloClient/BackendSubscriptionClientContext';
import { ErrorBoundary } from '@99designs/apps/spa/common/ErrorBoundary';
import { IntlProvider } from 'react-intl';
import ViewerProviderQuery from '@99designs/apps/spa/common/Viewer/ViewerContext';
import { SiteProvider } from '@99designs/apps/spa/common/SiteContext';
// @ts-ignore
import messages from 'GlobalNavMessages'; // eslint-disable-line import/no-unresolved
import Routes from '@99designs/apps/spa/routes';
import { SnackbarProvider } from '@99designs/purgatory';
import { Helmet } from 'react-helmet-async';
import { UIProvider } from '@99designs/ui';

interface Props {
    language: string;
    siteConfig: SiteConfig;
    backendSubscriptionClient?: SubscriptionClient;
}

class App extends React.Component<Props> {
    render() {
        const site = new Site(this.props.siteConfig);
        return (
            <React.StrictMode>
                <IntlProvider locale={this.props.language} messages={messages}>
                    <ErrorBoundary site={site}>
                        <SnackbarProvider>
                            <BackendSubscriptionClientProvider
                                value={this.props.backendSubscriptionClient}
                            >
                                <ViewerProviderQuery>
                                    <SiteProvider site={site}>
                                        <UIProvider
                                            translationStrings={{
                                                Alert: {
                                                    Dismiss: __('Dismiss'),
                                                },
                                                Modal: {
                                                    Close: __('Close'),
                                                },
                                                Select: {
                                                    Open: __('Open'),
                                                },
                                            }}
                                        >
                                            <Helmet
                                                titleTemplate="%s | 99designs"
                                                defaultTitle="99designs"
                                            />
                                            <Routes site={site} />
                                        </UIProvider>
                                    </SiteProvider>
                                </ViewerProviderQuery>
                            </BackendSubscriptionClientProvider>
                        </SnackbarProvider>
                    </ErrorBoundary>
                </IntlProvider>
            </React.StrictMode>
        );
    }
}

export default App;
